<template>
  <Grid gaf="column" justify-content="start" align-content="center" gap="var(--r-space-sm)">
    <RChip
      v-for="filter of availableFilters"
      :key="filter.value"
      :active="value.includes(filter.value)"
      @click="changeChipFilters(filter.value)"
    >
      {{ filter.label }}
    </RChip>
  </Grid>
</template>

<script>
// Components
import RChip from '@/ui/RChip'

export default {
  components: {
    RChip
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    availableFilters: [
      { label: 'Active subscriptions', value: 'current' },
      { label: 'One-time purchases', value: 'oneTimePurchase' }
    ]
  }),

  methods: {
    changeChipFilters(chipFilter) {
      if (this.value.includes(chipFilter)) {
        this.$emit(
          'input',
          this.value.filter(filter => filter !== chipFilter)
        )
      } else {
        this.$emit('input', [...this.value, chipFilter])
      }
    }
  }
}
</script>
